module.exports = __webpack_public_path__ + "img/H3.9b2c2754.png";